const DEFAULT_SLACK_WORKSPACES_PAGE = 1;
const DEFAULT_SLACK_WORKSPACES_LIMIT = 10;
const DEFAULT_TEAMS_TENANTS_PAGE = 1;
const DEFAULT_TEAMS_TENANTS_LIMIT = 10;

export interface MockSlackWorkspace {
  teamId: string;
  teamName: string;
  status: 'active' | 'disabled';
  createdAt: string;
}

interface MockSlackWorkspacePageParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface MockTeamsTenant {
  id: string;
  tenantId: string;
  tenantDisplayName: string | null;
  status: 'active' | 'disabled';
  linkedAt: string | null;
}

interface MockTeamsTenantPageParams {
  page?: number;
  limit?: number;
}

export const mockedSlackWorkspaces: MockSlackWorkspace[] = [
  { teamId: 'T100001', teamName: 'Scarb Leadership', status: 'active', createdAt: '2026-05-10T09:00:00.000Z' },
  { teamId: 'T100002', teamName: 'Scarb People Ops', status: 'active', createdAt: '2026-05-09T11:15:00.000Z' },
  { teamId: 'T100003', teamName: 'Scarb Support', status: 'disabled', createdAt: '2026-05-08T08:40:00.000Z' },
  { teamId: 'T100004', teamName: 'Scarb Engineering', status: 'active', createdAt: '2026-05-07T13:25:00.000Z' },
  { teamId: 'T100005', teamName: 'Scarb Product', status: 'active', createdAt: '2026-05-06T15:10:00.000Z' },
  { teamId: 'T100006', teamName: 'Scarb Marketing', status: 'disabled', createdAt: '2026-05-05T10:35:00.000Z' },
  { teamId: 'T100007', teamName: 'Scarb Customer Success', status: 'active', createdAt: '2026-05-04T14:55:00.000Z' },
  { teamId: 'T100008', teamName: 'Scarb Finance', status: 'active', createdAt: '2026-05-03T16:20:00.000Z' },
  { teamId: 'T100009', teamName: 'Scarb HR Partners', status: 'disabled', createdAt: '2026-05-02T12:05:00.000Z' },
  { teamId: 'T100010', teamName: 'Scarb Sales', status: 'active', createdAt: '2026-05-01T09:45:00.000Z' },
  { teamId: 'T100011', teamName: 'Scarb Legal', status: 'active', createdAt: '2026-04-30T17:00:00.000Z' },
  { teamId: 'T100012', teamName: 'Scarb Operations', status: 'disabled', createdAt: '2026-04-29T07:50:00.000Z' },
];

export const mockedTeamsTenants: MockTeamsTenant[] = [
  {
    id: 'teams-tenant-1',
    tenantId: 'tenant-demo-1',
    tenantDisplayName: 'Scarb Demo Tenant',
    status: 'active',
    linkedAt: '2026-04-18T10:00:00.000Z',
  },
  {
    id: 'teams-tenant-2',
    tenantId: 'tenant-demo-2',
    tenantDisplayName: 'Scarb Europe',
    status: 'active',
    linkedAt: '2026-04-12T09:30:00.000Z',
  },
  {
    id: 'teams-tenant-3',
    tenantId: 'tenant-demo-3',
    tenantDisplayName: null,
    status: 'active',
    linkedAt: '2026-04-08T14:20:00.000Z',
  },
  {
    id: 'teams-tenant-4',
    tenantId: 'tenant-demo-4',
    tenantDisplayName: 'Scarb LATAM',
    status: 'active',
    linkedAt: '2026-04-05T08:45:00.000Z',
  },
];

export const getMockSlackWorkspacePage = ({
  page = DEFAULT_SLACK_WORKSPACES_PAGE,
  limit = DEFAULT_SLACK_WORKSPACES_LIMIT,
  search,
}: MockSlackWorkspacePageParams) => {
  const normalizedSearch = search?.trim().toLowerCase();
  const filteredItems = normalizedSearch
    ? mockedSlackWorkspaces.filter((workspace) => workspace.teamName.toLowerCase().includes(normalizedSearch))
    : mockedSlackWorkspaces;
  const startIndex = (page - 1) * limit;
  const items = filteredItems.slice(startIndex, startIndex + limit);

  return {
    items,
    meta: {
      page,
      limit,
      total: filteredItems.length,
      totalPages: Math.ceil(filteredItems.length / limit),
    },
  };
};

export const getMockTeamsTenantPage = ({
  page = DEFAULT_TEAMS_TENANTS_PAGE,
  limit = DEFAULT_TEAMS_TENANTS_LIMIT,
}: MockTeamsTenantPageParams) => {
  const startIndex = (page - 1) * limit;
  const items = mockedTeamsTenants.slice(startIndex, startIndex + limit);

  return {
    items,
    meta: {
      page,
      limit,
      total: mockedTeamsTenants.length,
      totalPages: Math.ceil(mockedTeamsTenants.length / limit),
    },
  };
};
